import { addTenant as addTenantAPI } from "../../../apis/tenant";
import { updateTenant as updateTenantAPI } from "../../../apis/tenant";
import { addTenantUsers as addTenantUserAPI } from "../../../apis/tenant";
const isAutoPilotOn = (process.env.REACT_APP_GKE_AUTOPILOT==="TRUE"|| process.env.REACT_APP_GKE_AUTOPILOT==="true") ? true : false;

export const addTenant = async (data) => {
	const tenantId = data.tenantId;
	const orgName = data.orgName;
	const tier = data.tierval;
	const adminEmail = data.adminEmail;
	const orgLogo = data.orgLogo;
	const domain = data.domain;
	// const subnetSize = data.subnetSize;

	const isGPUEnabled = data.isGPUEnabled;
	const gpuType =  data.gpuType || null;
	const gpuCount = data.gpuCount || 0;

	const port = data.portNumber || null;
	const region = data.region || null;
	const gcpProjectId = data.projectId || null;
	const bqDataSetId = data.bqDatasetId || null;
	const zone = data.zone || null;
	const emailVerified = data.emailVerified;

	const machineType = data.machineType || null;
	const minCount = parseInt(data.minCount) || null;
	const maxCount = parseInt(data.maxCount) || null;
	const nodeCount = parseInt(data.nodeCount) || null;
	const podIp = data.podIp || null;
	const masterIp = data.masterIp || null;
	const subnetIp = data.subnetIp || null;
	const svcIp = data.svcIp || null;

	const baseFields = {
		orgName,
		subdomain: tenantId,
		adminEmail,
		tier,
		logoUrl: orgLogo,
		domain,
		gcpRegion: region,
		projectId: gcpProjectId,
		bqDatasetId: bqDataSetId,
		zone,
		port:port,
		// subnetSize,
		emailVerified,
		podIp,
		masterIp,
		subnetIp,
		svcIp,
		isAutoPilotOn: isAutoPilotOn
	};

	const additionalFields = (isAutoPilotOn != true) 
    ? {
        minCount,
        maxCount,
        nodeCount,
		machineType,
		isGPUEnabled,
		gpuType,
		gpuCount,
    }
    : {};

	const dataToSend = {
		...baseFields,
		...additionalFields,
	};

	let endpoint;
	if (tier === "freemium") {
		endpoint = "/api/trigger/freemium";
	} else if (tier === "enterprise") {
		endpoint = "/api/trigger/enterprise";
	}

	try {
		// console.log("enpoint", endpoint, dataToSend);
		const res = await addTenantAPI(endpoint, dataToSend);
		// console.log("response in add tenant", res);
		return res;
	} catch (error) {
		console.log("error in add tenant", error);
		return error.response;
	}
};

export const updateTenant = async (data) => {
	const tenantId = data.tenantId;
	const orgName = data.orgName;
	const tier = data.tier;
	const adminEmail = data.adminEmail;
	const orgLogo = data.orgLogo;
	const domain = data.domain;

	const region = data.region || null;
	const gcpProjectId = data.gcpProjectId || null;
	const bqDataSetId = data.bqDataSetId || null;
	const machineType = data.machineType || null;
	const zone = data.zone || null;
	const minCount = parseInt(data.minCount) || null;
	const maxCount = parseInt(data.maxCount) || null;
	const nodeCount = parseInt(data.nodeCount) || null;
	const podIp = data.podIp || null;
	const masterIp = data.masterIp || null;
	const subnetIp = data.subnetIp || null;
	const svcIp = data.svcIp || null;

	const dataToSend = {
		orgName,
		subdomain: tenantId,
		adminEmail,
		tier: tier,
		logoUrl: orgLogo,
		domain,
		gcpRegion: region,
		gcpProjectId,
		bqDataSetId,
		machineType,
		zone,
		minCount,
		maxCount,
		nodeCount,
		podIp,
		masterIp,
		subnetIp,
		svcIp,
	};

	// console.log("data in edit tenant", dataToSend);
	// let isValidated = validateTenantData(dataToSend)
	try {
		const res = await updateTenantAPI(dataToSend);
		// console.log("res in edit tenant", res);
		return res.status;
	} catch (error) {
		console.log("error in edit tenant", error);
		return error.response.status;
	}
};

export const addTenantUser = async (data) => {
	const userName = data.userName;
	const userEmail = data.userEmail;
	const domain = data.domain;

	const dataToSend = {
		userName,
		userEmail,
		domain,
	};

	// console.log(dataToSend);

	try {
		const res = await addTenantUserAPI(dataToSend);
		return res.status;
	} catch (error) {
		console.error(error);
		return error.response.status;
	}
};
